$(document).on('click', '.glyph-offcanvas', function (e) {
    e.preventDefault();

    try {
        var targetOffcanvas =$(this).data('bs-target');
        var offcanvasElement = bootstrap.Offcanvas.getOrCreateInstance($(targetOffcanvas));

        var url = $(this).attr('href') || '';
        url = url.replaceAll('#', '');
        if (!url) {
            offcanvasElement.show();
        } else {
            $.ajax({
                url: url,
                type: "GET",
                beforeSend: function () {
                    $(targetOffcanvas+' .offcanvas-body').html('<div class="spinner-border text-primary" role="status"></div>');
                },
                success: function (response) {
                    if (response.code === 200 && response.data && response.data.html) {
                        $(targetOffcanvas+" .offcanvas-body").html(response.data.html);
                        offcanvasElement.show();

                        if ($(targetOffcanvas + " .offcanvas-body").find("select").length > 0) {
                            initializeSelect2();
                        }
                    } else {
                        showAlert(ALERT_TYPE, response);
                    }
                },
                error: function (xhr, status, error) {
                    let errorMessage = `<p class="alert alert-danger" role="alert">Error: ${error}</p>`;
                    $(targetOffcanvas+" .offcanvas-body").html(errorMessage);
                }
            })
        }
    } catch (e) {
        console.log(e);
    }
});
$("#drawer").on("hidden.bs.offcanvas", function () {
    $("#drawer .offcanvas-body").html("");
});
